export default "__VITE_ASSET__51c19f7f__"